import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import { ReactComponent as ArrowIcon } from "@assets/images/icons/angle-right-orange.svg";
import lockImage from "@assets/images/copytrade/lock-image.png";
import percentImage from "@assets/images/copytrade/percent-image.png";
import targetImage from "@assets/images/copytrade/target-image.png";

import "./CopytradeHeroSlider.sass";

import "swiper/css";
import "swiper/css/pagination";

const SLIDES_DATA = [
  {
    id: 1,
    title: "Smart Copy Protection",
    description: "Built-in risk protection for your first trades.",
    buttonText: "Start Copying",
    img: lockImage,
  },
  {
    id: 2,
    title: "Discover Top Strategies",
    description: "Explore verified traders and performance data.",
    buttonText: "Explore Traders",
    img: percentImage,
  },
  {
    id: 3,
    title: "Advanced Risk Controls",
    description: "Control risk, drawdown, and position size.",
    buttonText: "Learn More",
    img: targetImage,
  },
];

export const CopytradeHeroSlider = () => {
  return (
    <div className="copytrade-hero__slider">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={20}
        slidesPerView={1}
        loop={true}
        speed={800}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          el: ".copytrade-hero__slider-pagination", // Вказуємо наш кастомний контейнер для точок
        }}
        className="copytrade-hero__swiper"
      >
        {SLIDES_DATA.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="copytrade-hero__card">
              <div className="copytrade-hero__card-description">
                <h3 className="copytrade-hero__card-title">{slide.title}</h3>
                <p>{slide.description}</p>
              </div>

              <a href="#start" className="copytrade-hero__card-link">
                {slide.buttonText}
                <ArrowIcon />
              </a>

              <img
                src={slide.img}
                className="copytrade-hero__card-image"
                alt={slide.title}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="copytrade-hero__slider-pagination"></div>
    </div>
  );
};
